<p class="mb-3" role="status" aria-live="polite">
  {{ (canExtend ? 'AuthSecurity.session_expiring_body' : 'AuthSecurity.session_ending_body') | translate:{seconds: remainingSeconds()} }}
</p>

<div class="d-flex justify-content-end">
  <button type="button" class="btn btn-default me-2" [disabled]="refreshing()" (click)="signOut()">
    {{ 'AuthSecurity.session_sign_out' | translate }}
  </button>
  @if (canExtend) {
  <button type="button" class="btn btn-primary" [disabled]="refreshing()" (click)="staySignedIn()">
    {{ 'AuthSecurity.session_stay' | translate }}
  </button>
  }
  @if (!canExtend) {
  <button type="button" class="btn btn-primary" (click)="continueWorking()">
    {{ 'AuthSecurity.session_continue' | translate }}
  </button>
  }
</div>
